import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import ProgressBar from '../ProgressBar/ProgressBar';
import {HOST} from '../config';
import './BooksOverview.css';

const BooksOverview = () => {
    const [summary, setSummary] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(HOST + '/api/books/summary')
            .then((response) => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then((data) => {
                setSummary(data);
                setLoading(false);
            })
            .catch((err) => {
                console.error('Error fetching books summary:', err);
                setError('Failed to fetch books overview.');
                setLoading(false);
            });
    }, []);

    if (loading) return <div>Loading books overview...</div>;
    if (error) return <div>{error}</div>;

    const title = summary.themes.length === 1 ? summary.themes[0] : 'Books';

    return (
        <div className="books-overview">
            <Link to="/" className="back-link">&larr; Back</Link>
            <h1>{title}</h1>
            <p className="total-cards">{summary.totalCards} cards total</p>
            {summary.progress && <ProgressBar {...summary.progress} />}
            <Link to="/books/study" className="study-button">
                Jump into exercise
            </Link>

            <h2 className="books-overview-section">Books</h2>
            <ul className="books-overview-list">
                {summary.books.map((b) => (
                    <li key={b.setId}>
                        <Link to={`/sets/${b.setId}`}>
                            <h3>{b.title.replace(/ Flashcards$/, '')}</h3>
                            {b.author && <p className="book-author">{b.author}</p>}
                            <p className="book-card-count">{b.totalCards} cards</p>
                            {b.progress && <ProgressBar {...b.progress} />}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default BooksOverview;
